import React from "react";
import { Link } from "react-router-dom";

import Header from "../../components/header";

import "./styles.css";
import "../../styles/Loader.css";

const DomainError = () => {
  return (
    <div>
      <div>
        <Header
          headerHeading="NVIDIA Application Hub"
          loginHeader={true}
          dashboardHeader={false}
        ></Header>
        <div className="centered-message-app">
          <div className="centered-message">
            <p>
              {" "}
              Your login session could not be validated. Please try again. 
              <Link className="sign-in-text sign-in-text-medium" to="/login">
                Login
              </Link>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DomainError;
